import { Box, Typography } from '@mui/material';
import { PlatformPersonas } from '@cowbell/data';

import { UserAvatarMenu } from './modules/UserAvatarMenu';
import { HeaderItems } from './HeaderItems';

import { withShowable } from '../../../_global/lib/withShowable';
import { REDACTED_FIELD } from '../../../../config/logrocket';

/** Personas whose header is just the account name and the avatar menu. */
const ACCOUNT_NAME_HEADER_PERSONAS: readonly string[] = [
  PlatformPersonas.DIGITAL,
  PlatformPersonas.MSSP,
  PlatformPersonas.CARRIER,
  PlatformPersonas.RE_INSURER,
  PlatformPersonas.PREMIUM_PROCESSOR,
  PlatformPersonas.CLUSTER,
  PlatformPersonas.VENDOR,
  PlatformPersonas.POOL,
];

export const usesAccountNameHeader = (personaType: string | undefined) =>
  ACCOUNT_NAME_HEADER_PERSONAS.some((type) => type === personaType);

interface AccountNameHeaderProps {
  readonly account: { readonly name: string };
}

const AccountNameHeader = ({ account }: AccountNameHeaderProps) => (
  <HeaderItems>
    <Box>
      <Typography className={`${REDACTED_FIELD} tertia-text`}>
        {account.name}
      </Typography>
    </Box>

    <Box>
      <UserAvatarMenu />
    </Box>
  </HeaderItems>
);

export default withShowable(AccountNameHeader);
